import React from 'react';
import PropTypes from 'prop-types';
import JobsSection from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/DetailPicker/Details/Templates/JobsPicker/Jobs/Content/JobsSectionPicker/JobsSection/Content';

const JobsSectionPicker = ({ relationship }) => {
  return (
    <JobsSection relationship={relationship} />
  );
};

JobsSectionPicker.propTypes = {
  relationship: PropTypes.object.isRequired,
};

export default JobsSectionPicker;
